import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface PreviewState {
  value: boolean;
}

const initialState: PreviewState = {
  value: false,
};

export const previewSlice = createSlice({
  name: "preview",
  initialState,
  reducers: {
    setPreview: (state, action: PayloadAction<boolean>) => {
      state.value = action.payload;
    },
  },
});

export const { setPreview } = previewSlice.actions;
